import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f9c699ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["line-type-chip", {
      disabled: $props.disabled,
      small: $props.isSmallSize,
      forward: $props.lineTypeCode === $setup.LineTypeCode.Forward,
      backward: $props.lineTypeCode === $setup.LineTypeCode.Backward,
      shuttle: $props.lineTypeCode === $setup.LineTypeCode.Shuttle,
      inside: $props.lineTypeCode === $setup.LineTypeCode.Inside,
    }])
  }, [
    _createElementVNode("span", null, _toDisplayString($props.lineTypeName), 1 /* TEXT */),
    ($setup.driveDatesDisplayText.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " / "))
      : _createCommentVNode("v-if", true),
    _createElementVNode("span", null, _toDisplayString($setup.driveDatesDisplayText), 1 /* TEXT */)
  ], 2 /* CLASS */))
}